import _ from 'lodash';

export const getPatientCmsData = (patient) =>
  patient ? _.pick(patient, ['nursingHomeStatus', 'referralSource', 'residenceType']) : null;
